import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { DocumentPreview } from '../../../../../../shared/general/components/document-preview/document-preview';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { DocumentService } from '../../../../../../shared/general/services/document.service';

@Component({
  selector: 'app-listing-form-review',
  imports: [
    CommonModule,
    DocumentPreview,
    MatCardModule,
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './listing-form-review.html',
  styleUrl: './listing-form-review.scss',
})
export class ListingFormReview {
  private documentService = inject(DocumentService);

  @Input() pdfUrlForPreview: string | ArrayBuffer | Uint8Array | null = "/assets/files/Sales_Consultant_Listing_Form.pdf";

  constructor() {
    this.documentService.loadSavedForm().subscribe((data: any) => {
      console.log('data', data);
    });
  }
}
